import { Youtube, Instagram, Facebook, type LucideIcon } from "lucide-react";

/**
 * Yoluno's social channels — the single source of truth for the footer, the
 * side rail, and the Watch page. Add a channel here and it appears everywhere.
 *
 * Only ever list URLs that are live. A social icon leading to a 404 is worse
 * than a missing icon, and on a children's platform it reads as neglect.
 *
 * The Facebook entry is the canonical page URL, resolved from the app share
 * link (facebook.com/share/19gy5NkKUM) — share links carry `mibextid` tracking
 * parameters that don't belong in our markup.
 *
 * Still to add once the account exists:
 *   TikTok — no lucide icon; needs a small inline SVG
 */

export interface SocialLink {
  label: string;
  href: string;
  Icon: LucideIcon;
}

export const YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@Yoluno-kids";

export const socialLinks: SocialLink[] = [
  { label: "YouTube", href: YOUTUBE_CHANNEL_URL, Icon: Youtube },
  { label: "Instagram", href: "https://www.instagram.com/yoluno.kids/", Icon: Instagram },
  { label: "Facebook", href: "https://www.facebook.com/people/Yoluno/61592082663053/", Icon: Facebook },
];
